module.exports = __webpack_public_path__ + "img/hyperLogo.c7e5e34b.png";